// extracted by mini-css-extract-plugin
module.exports = {"image":"umbraco-image_image__W8vK4","initialHeight":"umbraco-image_initialHeight__ISaHT"};